import getPlanIdWorkoutUtil from '../../../../../modules/workout/model/utils/get-plan-id'
import isInPlanWorkoutUtil from '../../../../../modules/workout/model/utils/is-in-plan'
import getByIdPlanSelector from '../../../../plans/selectors/get-by-id'
import saveReduxAction from '../../../../redux/actions/save'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import isNewReduxUtil from '../../../../redux/utils/is-new'
import WORKOUTS_ACTION from '../../constants/action'
import WORKOUTS_ENDPOINT from '../../constants/endpoint'
import canEditByIdWorkoutSelector from '../../selectors/can-edit-by-id'
import getByIdWorkoutSelector from '../../selectors/get-by-id'
import { getDomainListPathWorkoutUtil } from '../../../../../modules/workout/model/utils/get-domain-list-paths'

function saveWorkoutAction (id, params = {}) {
  return (dispatch, getState) => {
    const workout = getByIdWorkoutSelector(id)(getState())
    if (!workout) {
      return
    }

    if (!canEditByIdWorkoutSelector(id)(getState())) {
      return
    }

    let plan
    if (isInPlanWorkoutUtil(workout)) {
      const planId = getPlanIdWorkoutUtil(workout)
      plan = getByIdPlanSelector(planId)(getState())
    }

    // If it's in a plan and the plan is not saved, no-op
    // It will get saved when plan gets saved
    if (plan && isNewReduxUtil(plan)) {
      // console.debug(`saveWorkoutAction: [noop] workout with id
      // ${getIdReduxUtil(workout)} is in unsaved plan`)
      return
    }

    // console.debug(`saveWorkoutAction: id ${getIdReduxUtil(workout)}`)
    // console.debug(`saveWorkoutAction: loggedAt ${getValueReduxUtil(workout,
    // WORKOUT_KEY.LOGGED_AT)}`)
    return dispatch(saveReduxAction({
      type: WORKOUTS_ACTION.SAVE,
      payload: {
        endpoint: WORKOUTS_ENDPOINT.WORKOUTS,
        domainListPath: getDomainListPathWorkoutUtil(workout, getState()),
        path: getPathReduxUtil(workout),
        ...params
      }
    }))
  }
}

export default saveWorkoutAction
